import { useMemo } from 'react';
import { useGET } from '../shared/hooks';

const toUrl = (stageId, limit, minPossessions, divisions, team) => {
  // https://api.pivotanalysis.app/api/impact?team=&stage=303&limit=500&min_possessions=100&divisions=&format=json
  let url = `/impact?stage=${stageId}&limit=${limit}&min_possessions=${minPossessions}&format=json`;
  if (team) url += `&team=${team}`;
  if (divisions) url += `&divisions=${Array.join(divisions, ',')}`;
  return url;
};

export default function useImpacts(
  stageId,
  limit = 500,
  minPossessions = 100,
  divisions = null,
  team = null,
) {
  const url = stageId
    ? toUrl(stageId, limit, minPossessions, divisions, team)
    : null;
  const data = useGET(url);
  return useMemo(() => data && data.results, [data]);
}
